import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import moment from "moment";

@Component({
    selector: "app-single-quarter-calendar",
    templateUrl: "./single-quarter-calendar.component.html",
    styleUrls: ["./single-quarter-calendar.component.scss"],
    standalone: false
})
export class SingleQuarterCalendarComponent implements OnInit {
  @Input() selectedData: any;
  @Input() DateConfig: any;
  @Output() applyFilter = new EventEmitter<any>();
  @Input() minYear: number = 2020;
  @Input() maxYear: number = new Date().getFullYear();
  headerName:any='Date Selection'
  allYears: number[] = [];
  quarters: string[] = [];
  selectedStartQuarter: string | null = null;
  selectedEndQuarter: string | null = null;
  minQuarter = "Q1 2023"; // Minimum quarter
  maxQuarter = "Q4 2025"; // Maximum quarter
  currentYear!: number;
  startYear: any;
  endYear: any;

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['selectedData']?.currentValue!=changes['selectedData']?.previousValue) {
      // debugger;
      this.minYear   =  Number(moment(this.DateConfig.option.minDate).format("YYYY")) - 2;
      this.startYear =  Number(moment(this.selectedData.to_date).format("YYYY")) - 2;
      this.endYear = Number(moment(this.selectedData.to_date).format("YYYY"));
      this.quarters = this.generateQuartersForRange(this.startYear, this.endYear);
      this.currentYear = new Date().getFullYear();
      // debugger
      this.minQuarter = this.getQuarter(this.DateConfig.option.minDate);
      this.maxQuarter = this.getQuarter(new Date());
      this.selectedStartQuarter = this.getQuarter(this.selectedData.from_date);
      this.selectedEndQuarter = this.getQuarter(this.selectedData.to_date);
    }
  }

  getQuarter(dateStr: any) {
    const date = new Date(dateStr);
    const quarter = Math.floor((date.getMonth() + 3) / 3); // Get quarter (1-4)
    return `Q${quarter} ${date.getFullYear()}`;
  }

  // Generate quarters for a range of years
  generateQuartersForRange(startYear: number, endYear: number): string[] {
    const quarters: string[] = [];
    for (let year = startYear; year <= endYear; year++) {
      quarters.push(...["Q1", "Q2", "Q3", "Q4"].map((q) => `${q} ${year}`));
    }
    return quarters;
  }
  // Get the start date of the selected quarter
  getQuarterStartDate(quarter: string): Date {
    const [q, year] = quarter.split(" ");
    const dates: any = { Q1: "01/01", Q2: "04/01", Q3: "07/01", Q4: "10/01" };
    return new Date(`${dates[q]}/${year}`);
  }

  // Get the end date of the selected quarter
  getQuarterEndDate(quarter: string): Date {
    const [q, year] = quarter.split(" ");
    const dates: any = { Q1: "03/31", Q2: "06/30", Q3: "09/30", Q4: "12/31" };
    return new Date(`${dates[q]}/${year}`);
  }
  // Select a quarter range
  selectQuarter(quarter: string): void {
    this.selectedStartQuarter = quarter;
    this.selectedEndQuarter = quarter;
  }

  // Check if the quarter is selected
  isSelected(quarter: string): boolean {
    return (
      this.selectedStartQuarter === quarter ||
      this.selectedEndQuarter === quarter
    );
  }
  // Check if the quarter is disabled based on min/max quarter range
  isDisabled(quarter: string): boolean {
    const quarterDate = this.getQuarterDate(quarter);
    const minDate = this.getQuarterDate(this.minQuarter);
    const maxDate = this.getQuarterDate(this.maxQuarter);

    if (!quarterDate || !minDate || !maxDate) {
        console.error("Invalid quarter or range.");
        return true;
    }

    return quarterDate < minDate || quarterDate > maxDate;
}

getQuarterDate(quarter: string): Date | null {
    const match = quarter.match(/^Q([1-4]) (\d{4})$/);
    if (!match) return null;

    const [_, q, year] = match.map(Number);
    const month = (q - 1) * 3; 
    return new Date(year, month, 1); 
}
  // Move the start year range backward
  moveStartYearPrevious(): void {
    if (this.startYear > this.minYear) {
      this.startYear--;
      this.quarters = this.generateQuartersForRange(
        this.startYear,
        this.startYear + 2
      );
    }
  }

  // Move the start year range forward
  moveStartYearNext(): void {
    if (this.startYear < this.maxYear) {
      this.startYear++;
      this.quarters = this.generateQuartersForRange(
        this.startYear,
        this.startYear + 2
      );
    }
  }

  // Clear selected quarter range
  clearSelection(): void {
    this.selectedStartQuarter = null;
    this.selectedEndQuarter = null;
  }

  // Apply selected quarter range and emit the filter event
  applySelection(): void {
    if (this.selectedStartQuarter && this.selectedEndQuarter) {
      const output = {
        from_date: this.selectedStartQuarter,
        to_date: this.selectedEndQuarter,
      };
      this.applyFilter.emit(output);
    } else {
      alert("Please select a start and end quarter.");
    }
     //menu close
     document.getElementById("du-page")?.click()
  }
}
